import React, { FC } from 'react'
import { Field, useFormikContext } from 'formik'
import { PaymentFormValues } from '@entities/payment'
import { steamPromocodeAddGtm } from '@shared/lib/gtm/redesign'
import { DiscountIcon } from '@shared/assets/icons'
import { InputField } from '@shared/ui/organisms'
import { Amount } from '@root/api/ump-ewallet'
import ActivatePromocodeButton from './ActivatePromocodeButton'

interface SteamPromocodeFieldProps {
  getCommissions: (amount: Required<Pick<Amount, 'base' | 'fee' | 'total'>>, serviceId?: string) => void
}

const SteamPromocodeField: FC<SteamPromocodeFieldProps> = ({ getCommissions }) => {
  const { values, validateForm, handleBlur } = useFormikContext<PaymentFormValues>()

  const handlePromocodeFieldBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    const validationErrors = await validateForm()

    if (!validationErrors?.promocode && values.promocode?.trim()) {
      steamPromocodeAddGtm()
    }

    handleBlur(e)
  }

  return (
    <Field
      size={{ desktop: '72', mobile: '64' }}
      name="promocode"
      label="Промокод"
      icon={<DiscountIcon />}
      button={<ActivatePromocodeButton getCommissions={getCommissions} />}
      onBlur={handlePromocodeFieldBlur}
      component={InputField}
    />
  )
}

export default SteamPromocodeField
